import React, { useState, useEffect } from 'react';
import '../styles/GuestForm.css';

const GuestForm = ({ guest, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    Sequence: '',
    prenom: '',
    nom: '',
    passportNo: '',
    hotel: '',
    chambre: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (guest) {
      setFormData({
        Sequence: guest.Sequence || '',
        prenom: guest.prenom || '',
        nom: guest.nom || '',
        passportNo: guest.passportNo || '',
        hotel: guest.hotel || '',
        chambre: guest.chambre || ''
      });
    }
  }, [guest]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.Sequence.toString().trim() || !formData.prenom.trim() || !formData.nom.trim() || !formData.passportNo.trim() || 
        !formData.hotel.trim() || !formData.chambre.trim()) {
      setError('Tous les champs sont obligatoires.');
      return;
    }

    setLoading(true);
    const result = await onSubmit(formData);
    setLoading(false);
    
    if (!result.success) {
      setError(result.message);
    }
  };

  return (
    <div className="form-overlay">
      <div className="form-container animate-fade-in">
        <div className="form-header">
          <h3>{guest ? 'Modifier Pèlerin' : 'Ajouter un Pèlerin'}</h3>
          <button className="close-button" onClick={onCancel} disabled={loading} title="Fermer">
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="form-content">
          {error && <div className="error-message" style={{color: '#ef4444', background: '#fef2f2', padding: '1rem', borderRadius: '4px'}}>{error}</div>}
          
          <div className="form-group">
            <label htmlFor="Sequence">
              Séquence <span className="required">*</span>
            </label>
            <input
              type="number"
              id="Sequence"
              name="Sequence"
              value={formData.Sequence}
              onChange={handleChange}
              placeholder="Numéro Séquence"
              disabled={loading}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="prenom">
              Prénom <span className="required">*</span>
            </label>
            <input
              type="text"
              id="prenom"
              name="prenom"
              value={formData.prenom}
              onChange={handleChange}
              placeholder="Entrez le prénom"
              disabled={loading}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="nom">
              Nom <span className="required">*</span>
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              placeholder="Entrez le nom"
              disabled={loading}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="passportNo">
              Numéro de Passeport <span className="required">*</span>
            </label>
            <input
              type="text"
              id="passportNo"
              name="passportNo"
              value={formData.passportNo}
              onChange={handleChange}
              placeholder="Ex: SE123456"
              disabled={loading}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="hotel">
              Hôtel <span className="required">*</span>
            </label>
            <input
              type="text"
              id="hotel"
              name="hotel"
              value={formData.hotel}
              onChange={handleChange}
              placeholder="Nom de l'hôtel"
              disabled={loading}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="chambre">
              Chambre <span className="required">*</span>
            </label>
            <input
              type="text"
              id="chambre"
              name="chambre"
              value={formData.chambre}
              onChange={handleChange}
              placeholder="Numéro de la chambre"
              disabled={loading}
              required
            />
          </div>
          
          <div className="form-actions">
            <button 
              type="button" 
              className="cancel-button" 
              onClick={onCancel}
              disabled={loading}
            >
              Annuler
            </button>
            <button 
              type="submit" 
              className="submit-button"
              disabled={loading}
            >
              {loading ? 'Traitement en cours...' : (guest ? 'Mettre à jour' : 'Créer')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GuestForm;